export function TermsOfService() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: March 14, 2026</p>

      <div className="space-y-8 text-gray-700 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using SmartCatalog (&quot;the Service&quot;), operated by Winding River
            Software, you agree to be bound by these Terms of Service. If you do not agree, do
            not use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Description of Service</h2>
          <p>
            SmartCatalog is a product catalog management application that helps businesses manage
            inventory, analyze product images with AI, and synchronize catalogs with Square
            point-of-sale systems.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">3. User Accounts</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You must sign in with a valid Google account to use the Service</li>
            <li>You are responsible for maintaining the security of your account</li>
            <li>You must not share your account credentials with others</li>
            <li>You must provide accurate information when using the Service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Use the Service for any unlawful purpose</li>
            <li>Upload content that infringes on intellectual property rights</li>
            <li>Attempt to gain unauthorized access to the Service or its systems</li>
            <li>Interfere with the proper functioning of the Service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Third-Party Services</h2>
          <p>
            The Service integrates with Google (authentication, Drive) and Square
            (catalog sync). Your use of these integrations is subject to each provider&#39;s
            own terms of service. We are not responsible for third-party service availability
            or changes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Intellectual Property</h2>
          <p>
            You retain ownership of all content you upload to the Service. By uploading content,
            you grant us a limited license to process it for Service functionality (e.g., AI
            analysis, Square synchronization).
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Disclaimer of Warranties</h2>
          <p>
            The Service is provided &quot;as is&quot; without warranties of any kind, whether
            express or implied. We do not guarantee uninterrupted or error-free operation.
            AI-generated product descriptions are suggestions and should be reviewed before use.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Winding River Software shall not be liable
            for any indirect, incidental, special, or consequential damages arising from your
            use of the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Termination</h2>
          <p>
            We may suspend or terminate your access to the Service at any time for violation of
            these terms. You may stop using the Service at any time by disconnecting your
            integrations and contacting us to delete your account.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use of the Service after
            changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Contact</h2>
          <p>
            Questions about these Terms? Contact us at:{' '}
            <a
              href="mailto:support@windingriversoftware.com"
              className="text-blue-600 hover:underline"
            >
              support@windingriversoftware.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
